<template>
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="20.4078"
      cy="17.8746"
      r="7.83256"
      fill="#D1D7DF"
    />
    <path
      d="M25.6656 33.795H15.4518C15.0825 33.795 14.7871 33.4985 14.7871 33.128V30.3011C14.7871 29.9305 15.0825 29.634 15.4518 29.634H25.6656C26.0349 29.634 26.3303 29.9305 26.3303 30.3011V33.128C26.3303 33.4985 26.0349 33.795 25.6656 33.795ZM16.1166 32.461H25.0114V30.9681H16.1166V32.461Z"
      :fill="fill"
    />
    <path
      d="M25.6656 36.7502H15.4518C15.0825 36.7502 14.7871 36.4537 14.7871 36.0832V33.1292C14.7871 32.7586 15.0825 32.4622 15.4518 32.4622H25.6656C26.0349 32.4622 26.3303 32.7586 26.3303 33.1292V36.0832C26.3303 36.4537 26.0349 36.7502 25.6656 36.7502ZM16.1166 35.4161H25.0114V33.7962H16.1166V35.4161Z"
      :fill="fill"
    />
    <path
      d="M22.5 40.0005H18.6276C18.2583 40.0005 17.9629 39.704 17.9629 39.3335V36.083C17.9629 35.7125 18.2583 35.416 18.6276 35.416H22.5C22.8693 35.416 23.1647 35.7125 23.1647 36.083V39.3335C23.1647 39.704 22.8693 40.0005 22.5 40.0005ZM19.2818 38.6664H21.8352V36.7395H19.2818V38.6664Z"
      :fill="fill"
    />
    <path
      d="M24.7587 30.9702H16.3809C16.0117 30.9702 15.7162 30.6738 15.7162 30.3032V27.8892C11.7806 26.0152 9.25879 22.0342 9.25879 17.6403C9.25879 11.383 14.334 6.29028 20.5698 6.29028C26.8057 6.29028 31.8809 11.383 31.8809 17.6403C31.8809 22.0342 29.3591 26.0152 25.4235 27.8892V30.3032C25.4129 30.6738 25.1175 30.9702 24.7587 30.9702ZM17.0351 29.6468H24.094V27.5398C24.0623 27.2539 24.2206 26.9786 24.4844 26.8622C28.1668 25.2846 30.5409 21.6636 30.5409 17.6509C30.5409 12.1241 26.0565 7.63492 20.5593 7.63492C15.062 7.63492 10.5777 12.1241 10.5777 17.6509C10.5777 21.6636 12.9518 25.2846 16.6342 26.8622C16.9085 26.9786 17.0668 27.2539 17.0351 27.5504V29.6468Z"
      :fill="fill"
    />
    <path
      d="M6.74756 18.5696H3.49774C3.12845 18.5696 2.83301 18.2732 2.83301 17.9026C2.83301 17.5321 3.12845 17.2356 3.49774 17.2356H6.75811C7.12741 17.2356 7.42285 17.5321 7.42285 17.9026C7.41229 18.2732 7.11686 18.5696 6.74756 18.5696Z"
      :fill="fill"
    />
    <path
      d="M37.8638 18.5696H34.614C34.2447 18.5696 33.9492 18.2732 33.9492 17.9026C33.9492 17.5321 34.2447 17.2356 34.614 17.2356H37.8638C38.2331 17.2356 38.5285 17.5321 38.5285 17.9026C38.5285 18.2732 38.2331 18.5696 37.8638 18.5696Z"
      :fill="fill"
    />
    <path
      d="M8.53026 30.7679C8.36144 30.7679 8.19262 30.7044 8.066 30.5774C7.80222 30.3127 7.80222 29.8997 8.066 29.6351L10.3662 27.3269C10.63 27.0622 11.0415 27.0622 11.3053 27.3269C11.5691 27.5916 11.5691 28.0045 11.3053 28.2692L9.00507 30.5774C8.8679 30.7044 8.69908 30.7679 8.53026 30.7679Z"
      :fill="fill"
    />
    <path
      d="M30.5293 8.69152C30.3605 8.69152 30.1916 8.628 30.065 8.50095C29.8012 8.23625 29.8012 7.82333 30.065 7.55864L32.3652 5.25052C32.629 4.98583 33.0405 4.98583 33.3043 5.25052C33.5681 5.51521 33.5681 5.92813 33.3043 6.19283L31.0041 8.49036C30.8669 8.628 30.6981 8.69152 30.5293 8.69152Z"
      :fill="fill"
    />
    <path
      d="M20.6852 4.59506C20.3159 4.59506 20.0205 4.29861 20.0205 3.92804V0.667025C20.0205 0.296456 20.3159 0 20.6852 0C21.0545 0 21.35 0.296456 21.35 0.667025V3.93862C21.3394 4.29861 21.044 4.59506 20.6852 4.59506Z"
      :fill="fill"
    />
    <path
      d="M32.8295 30.7665C32.6607 30.7665 32.4918 30.7029 32.3652 30.5759L30.065 28.2678C29.8012 28.0031 29.8012 27.5902 30.065 27.3255C30.3288 27.0608 30.7403 27.0608 31.0041 27.3255L33.3043 29.6336C33.5681 29.8983 33.5681 30.3112 33.3043 30.5759C33.1671 30.7029 32.9983 30.7665 32.8295 30.7665Z"
      :fill="fill"
    />
    <path
      d="M10.8293 8.69113C10.6605 8.69113 10.4916 8.6276 10.365 8.50055L8.05428 6.18184C7.7905 5.91715 7.7905 5.50423 8.05428 5.23954C8.31807 4.97484 8.72957 4.97484 8.99335 5.23954L11.2935 7.54766C11.5573 7.81235 11.5573 8.22527 11.2935 8.48996C11.1669 8.6276 10.9981 8.69113 10.8293 8.69113Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'IconsVerticalsHomeEnergy'
})

defineProps({
  fill: {
    type: String,
    default: semanticColorLookup('surface.on-surface')
  }
})
</script>
